/**
 * Administrador
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseExclude} from 'simpli-web-sdk'
import {AdministradorCollection} from '@/model/collection/AdministradorCollection'

/* TODO: review generated class */
export class Administrador extends Resource {
  idAdministradorPk: number = 0

  nome: string | null = null
  email: string | null = null
  dataCriacao: string | null = null

  @ResponseExclude()
  senha: string | null = null

  get $id() {
    return this.idAdministradorPk
  }
  set $id(val) {
    this.idAdministradorPk = val
  }
  get $tag() {
    return String(this.nome)
  }

  /**
   * Gets a instance of a given ID of Administrador
   */
  async getAdministrador(id: number) {
    return await Request.get(`/admin/administrador/${id}`)
      .name('getAdministrador')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of Administrador
   */
  static async listAdministrador(params: any) {
    return await Request.get(`/admin/administrador`, {params})
      .name('listAdministrador')
      .as(AdministradorCollection)
      .getData()
  }

  /**
   * Persists a new instance of Administrador. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistAdministrador() {
    return await Request.post(`/admin/administrador`, this)
      .name('persistAdministrador')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Administrador to use it in a CSV file
   */
  static async listCsvAdministrador(params: any) {
    return await Request.get(`/admin/administrador/csv`, {params})
      .name('listCsvAdministrador')
      .as(AdministradorCollection)
      .getData()
  }
}
